import React, { memo } from 'react'

import { Module } from "../Styles"

import { Metadata } from "./Patient/Metadata"
import { Biometrics } from "./Patient/Biometrics"
import { History } from "./Patient/History"
import { Charting } from "./Patient/Charting"

import { usePatientData } from '../hooks/usePatientData'
import { useCaseViewContext } from '../context/CaseViewContext'

export const Patient = memo(({ patientRef }) => {
    const { caseDetails, fetchCaseDetails, patient: contextPatient, apiClasses, apiType } = useCaseViewContext()
    const patientId = caseDetails?.patient?._id || caseDetails?.patientId
    const caseId = caseDetails?._id || caseDetails?.caseId

    const apiPatientData = usePatientData(patientId, caseId, apiType, apiClasses, fetchCaseDetails)

    const contextPatientData = contextPatient && caseDetails ? {
        patientDetails: {
            ...caseDetails.patient,
            _id: caseDetails.patient?._id || caseDetails.patientId,
            heightFt: caseDetails.heightFt,
            heightIn: caseDetails.heightIn,
            weight: caseDetails.weight,
            bloodPressure: caseDetails.bloodPressure,
            medications: caseDetails.medications,
            allergies: caseDetails.allergies,
            state: caseDetails.state ? { name: caseDetails.state } : null
        },
        patientDetailsLoading: false,
        patientAllergies: apiPatientData?.patientAllergies || [],
        patientAllergiesLoading: apiPatientData?.patientAllergiesLoading || false,
        error: null
    } : null;
    
    const patientData = contextPatientData || apiPatientData

    return (
        <Module width="30%" ref={patientRef}>
            <Metadata patientData={patientData} />
            <Biometrics 
                patientData={patientData} 
                fetchPatientAllergies={apiPatientData?.fetchPatientAllergies}
            />
            <History />
            <Charting />
        </Module>
    )
})
